import { Skeleton } from "@/components/ui/skeleton";

export const NavigationSkeleton = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-white border-t border-gray-200 px-1 py-2">
      <div className="flex justify-around">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex flex-col items-center p-1">
            <Skeleton className="h-5 w-5 rounded" />
            <Skeleton className="h-3 w-8 mt-1" />
          </div>
        ))}
      </div>
    </div>
  );
};